import React, { useLayoutEffect, useRef } from 'react'
import UrlInput from './UrlInput'
import { QRNormal, QRResImage, QRRandRect, QRFunc, QRDsj, QRBubble, QRLine, QRImage} from 'react-qrbtf'
import { QRCode } from 'react-qrcode-logo'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

function hexToRgb(hex) {
	let h = String(hex || '').replace('#', '');
	if (h.length === 3) {
		h = h.split('').map((c) => c + c).join('');
	}
	const n = parseInt(h, 16);
	return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

// react-qrcode-logo has no gradient prop: recolor the drawn canvas.
// Each pixel on the bg→fg line keeps its share of fg (antialiased edges included),
// with fg replaced by the gradient color at that point. Other colors (markers in
// their own color) stay. The logo is drawn later on image load, so it is not touched.
export function applyGradient(canvas, fgColor, bgColor, type, color1, color2) {
	const ctx = canvas.getContext('2d');
	const w = canvas.width;
	const h = canvas.height;
	const fg = hexToRgb(fgColor);
	const bg = hexToRgb(bgColor);
	const d = [fg[0] - bg[0], fg[1] - bg[1], fg[2] - bg[2]];
	const dd = d[0] * d[0] + d[1] * d[1] + d[2] * d[2];
	if (dd === 0) {
		return;
	}

	const layer = document.createElement('canvas');
	layer.width = w;
	layer.height = h;
	const lctx = layer.getContext('2d');
	const g = type === 'radial'
		? lctx.createRadialGradient(w / 2, h / 2, 0, w / 2, h / 2, Math.hypot(w, h) / 2)
		: lctx.createLinearGradient(0, 0, w, h);
	g.addColorStop(0, color1);
	g.addColorStop(1, color2);
	lctx.fillStyle = g;
	lctx.fillRect(0, 0, w, h);
	const grad = lctx.getImageData(0, 0, w, h).data;

	const img = ctx.getImageData(0, 0, w, h);
	const px = img.data;
	for (let i = 0; i < px.length; i += 4) {
		const p = [px[i] - bg[0], px[i + 1] - bg[1], px[i + 2] - bg[2]];
		const t = (p[0] * d[0] + p[1] * d[1] + p[2] * d[2]) / dd;
		if (t <= 0 || t > 1.01) {
			continue;
		}
		// distance from the bg→fg line: skip colors that are not a fg/bg mix
		const off = Math.abs(p[0] - t * d[0]) + Math.abs(p[1] - t * d[1]) + Math.abs(p[2] - t * d[2]);
		if (off > 24) {
			continue;
		}
		for (let c = 0; c < 3; c++) {
			px[i + c] = Math.round(bg[c] + t * (grad[i + c] - bg[c]));
		}
	}
	ctx.putImageData(img, 0, 0);
}


const ComponentToPrint = React.forwardRef((props, ref) => {
   	      let isVisiableQR = props.isVisiableQR;
		  let idQR = props.idQR;
		  let valueQR = props.valueQR;
		  let sizeQR = props.sizeQR;
		  let sizeCustomQR = props.sizeCustomQR || 500;
		  let opacityQR = props.opacityQR;
		  let levelQR = props.levelQR;
		  let typeQR = props.typeQR;
		  let posTypeQR = props.posTypeQR;
		  let posTypeQR2 = props.posTypeQR2;
		  let otherColorQR = props.otherColorQR;
		  let posColorQR = props.posColorQR;
		  let bgColorQR = props.bgColorQR || '#FFFFFF';
		  let scaleQR = props.scaleQR;
		  let crossWidthQR = props.crossWidthQR;
		  let posWidhQR = props.posWidhQR;
		  let icon = props.icon;
		  let logoSizeQR = props.logoSizeQR || 20;
		  let qrStyleCustom = props.qrStyleCustom || 'squares';
		  let eyeRadiusQR = props.eyeRadiusQR || 0;
		  let logoPaddingQR = props.logoPaddingQR || 0;
		  let eyeColorQR = props.eyeColorQR || otherColorQR;
		  let gradientType = props.gradientType || 'none';
		  let gradientColor1 = props.gradientColor1 || '#000000';
		  let gradientColor2 = props.gradientColor2 || '#0000FF';
		  const isMarginQR= props.isMarginQR;
		  //design style
		  let QRstyle = props.QRstyle;
		  const customRef = useRef(null);
		  const hasGradient = QRstyle === "QRCustom" && gradientType !== 'none';

		  // Runs after QRCode has redrawn its canvas in the same commit.
		  // Deps mirror QRCode props: when none changed, QRCode did not redraw either.
		  useLayoutEffect(() => {
			const canvas = customRef.current && customRef.current.querySelector('canvas');
			if (hasGradient && canvas) {
				applyGradient(canvas, otherColorQR, bgColorQR, gradientType, gradientColor1, gradientColor2);
			}
		  }, [hasGradient, isVisiableQR, valueQR, sizeCustomQR, levelQR, bgColorQR, otherColorQR, eyeColorQR,
			  icon, logoSizeQR, logoPaddingQR, qrStyleCustom, eyeRadiusQR, isMarginQR,
			  gradientType, gradientColor1, gradientColor2]);

		  if (isVisiableQR === false)
			  { return (
			    <div ref={ref} className="qr-preview"><p>...</p></div>
			  )
			  }
	else
		if (QRstyle === "QRNormal")
		{
			return (
				<div ref={ref} className="qr-preview">					  
				  <QRNormal
					className="qr-preview__image"				
                    id={idQR}						
					value={valueQR}
					size={sizeQR}
					level={levelQR}
					type={typeQR}
					posType={posTypeQR}
					opacity={opacityQR}
					otherColor={otherColorQR}
					posColor={posColorQR}
					icon={icon}						
				  />
				  
				  
				</div>
			)
		}
	else
		if (QRstyle === "QRResImage")
		{
			return (
				<div ref={ref} className="qr-preview">
				  <QRResImage					    
					className="qr-preview__image"
					
					id={idQR}				
					value={valueQR}
					size={sizeQR}
					level={levelQR}
					type={typeQR}
					posType={posTypeQR}
					opacity={opacityQR}
					otherColor={otherColorQR}
					posColor={posColorQR}						
					image={icon}
					
				  />
				</div>
			)
		}
	else
		if (QRstyle === "QRImage")
		{
			return (
				<div ref={ref} className="qr-preview">
				  <QRImage					    
					className="qr-preview__image"
					
					id={idQR}				
					value={valueQR}
					size={sizeQR}
					level={levelQR}
					type={typeQR}
					posType={posTypeQR}
					opacity={opacityQR}
					otherColor={otherColorQR}
					posColor={posColorQR}						
					image={icon}
					
				  />
				</div>
			)
		}			
	else
		if (QRstyle === "QRRandRect")
		{
			return (
				<div ref={ref} className="qr-preview">
				  <QRRandRect					    
					className="qr-preview__image"						
					id={idQR}				
					value={valueQR}
					level={levelQR}
				  />
				</div>
			)
		}			
	else
		if (QRstyle === "QRBubble")
		{
			return (
				<div ref={ref} className="qr-preview">
				  <QRBubble					    
					className="qr-preview__image"						
					id={idQR}				
					value={valueQR}
					level={levelQR}
					posColor={posColorQR}												
				  />
				</div>
			)
		}						
	else
		if (QRstyle === "QRFunc")
		{
			return (
				<div ref={ref} className="qr-preview">
				  <QRFunc
					className="qr-preview__image"
					id={idQR}				
					value={valueQR}
					size={sizeQR}
					level={levelQR}
					includeMargin={isMarginQR}
				  />
				</div>
			)
		}
	else
		if (QRstyle === "QRDsj")
		{
			return (
				<div ref={ref} className="qr-preview">
				  <QRDsj
					className="qr-preview__image"				
                    id={idQR}						
					value={valueQR}						
					level={levelQR}
					scale={scaleQR}
					crossWidth={crossWidthQR}
					posWidh = {posWidhQR}
					posType={posTypeQR2}

				  />
				</div>
			)
		}
	else
		if (QRstyle === "QR25D")
		{
			return (
				<div ref={ref} className="qr-preview">
				  <QRFunc
					className="qr-preview__image"
					id={idQR}				
					value={valueQR}
					size={sizeQR}
					level={levelQR}						
				  />
				</div>
			)
		}			
	else
		if (QRstyle === "QRLine")
		{
			return (
				<div ref={ref} className="qr-preview">
				  <QRLine
					className="qr-preview__image"
					id={idQR}				
					value={valueQR}
					size={sizeQR}
					level={levelQR}
					includeMargin={isMarginQR}
				  />
				</div>
			)
		}
	else
		if (QRstyle === "QRCustom")
		{
			// Custom QR using react-qrcode-logo with full customization
			// Calculate logo size based on percentage
			const logoSize = (sizeCustomQR * logoSizeQR) / 100;
			
			// Eye radius for rounded corners on position patterns
			const eyeRadiusValue = eyeRadiusQR || 0;
			const eyeRadius = [
				{ outer: [eyeRadiusValue, eyeRadiusValue, eyeRadiusValue, eyeRadiusValue], inner: [0, 0, 0, 0] },
				{ outer: [eyeRadiusValue, eyeRadiusValue, eyeRadiusValue, eyeRadiusValue], inner: [0, 0, 0, 0] },
				{ outer: [eyeRadiusValue, eyeRadiusValue, eyeRadiusValue, eyeRadiusValue], inner: [0, 0, 0, 0] }
			];
			return (
				<div ref={ref} className="qr-preview">
				  <div className="qr-preview__inner" ref={customRef}>
					  <QRCode
						// remount on gradient change: QRCode redraws only on its own props,
						// and the recolor must start from a clean canvas
						key={hasGradient ? gradientType + gradientColor1 + gradientColor2 : 'plain'}
						id={idQR}
						value={valueQR}
						size={sizeCustomQR}
						ecLevel={levelQR}
						bgColor={bgColorQR}
						fgColor={otherColorQR}
						eyeColor={eyeColorQR}
						logoImage={icon}
						logoWidth={icon ? logoSize : 0}
						logoHeight={icon ? logoSize : 0}
						logoPadding={logoPaddingQR}
						removeQrCodeBehindLogo={icon ? true : false}
						qrStyle={qrStyleCustom}
						eyeRadius={eyeRadius}
						quietZone={isMarginQR ? 10 : 0}			
					  />
					</div>
				  </div>
			)
		}

   
   

});

class QRdiv extends React.Component {
	
constructor(props) {
   super(props);
   this.componentRef = React.createRef();
 }	

 // Custom export function to avoid cropping and blank PDFs
 exportAsImage(format) {
	const element = this.componentRef.current;
	
	if (!element) {
		alert('QR код еще не создан');
		return;
	}
	
	// Use async processing for all formats
	this.exportAsImageAsync(format);
 }

 // Async export for PNG, JPEG, PDF
 async exportAsImageAsync(format) {
	const element = this.componentRef.current;
	
	if (!element) {
		return;
	}
	
	try {
		
		// Wait a bit to ensure all images are loaded
		await new Promise(resolve => setTimeout(resolve, 200));
		
		// Get the actual rendered dimensions
		const rect = element.getBoundingClientRect();
		
		// Configure html2canvas with settings to prevent cropping
		const canvas = await html2canvas(element, {
			backgroundColor: '#ffffff',
			scale: 2, // Higher quality
			useCORS: true, // Allow cross-origin images
			allowTaint: true,
			logging: false,
			imageTimeout: 0,
			removeContainer: true,
			scrollY: -window.scrollY,
			scrollX: -window.scrollX,
			onclone: (clonedDoc) => {
				// Ensure the cloned element has proper dimensions
				const clonedElement = clonedDoc.querySelector('.qr-preview');
				if (clonedElement) {
					clonedElement.style.display = 'block';
					clonedElement.style.margin = '0';
					clonedElement.style.padding = '20px';
					clonedElement.style.boxSizing = 'content-box';
					clonedElement.style.overflow = 'visible';
					
					// Center the QR code
					const qrContent = clonedElement.querySelector('svg, canvas');
					if (qrContent) {
						qrContent.style.display = 'block';
						qrContent.style.margin = '0 auto';
						// mobile preview caps the height; export at full size
						qrContent.style.maxHeight = 'none';
					}
				}
			}
		});
		
		if (format === 'png') {
			// Export as PNG
			canvas.toBlob((blob) => {
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.download = 'sbQR_code.png';
				link.href = url;
				link.click();
				URL.revokeObjectURL(url);
			});
		} else if (format === 'jpeg') {
			// Export as JPEG
			canvas.toBlob((blob) => {
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.download = 'sbQR_code.jpeg';
				link.href = url;
				link.click();
				URL.revokeObjectURL(url);
			}, 'image/jpeg', 1.0);
		} else if (format === 'pdf') {
			// Export as PDF
			const imgData = canvas.toDataURL('image/png');
			const pdf = new jsPDF({
				orientation: canvas.width > canvas.height ? 'landscape' : 'portrait',
				unit: 'px',
				format: [canvas.width, canvas.height]
			});
			
			pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
			pdf.save('sbQR_code.pdf');
		}
	} catch (error) {
		console.error('Export error:', error);
		alert('Ошибка при экспорте. Попробуйте еще раз.');
	}
 }

render() {
	
   	      let isVisiableQR = this.props.isVisiableQR;
		  let idQR = this.props.idQR;
		  let valueQR = this.props.valueQR;
		  let sizeQR = this.props.sizeQR;
		  let sizeCustomQR = this.props.sizeCustomQR;
		  let opacityQR = this.props.opacityQR;
		  let levelQR = this.props.levelQR;
		  let typeQR = this.props.typeQR;
		  let posTypeQR = this.props.posTypeQR;
		  let posTypeQR2 = this.props.posTypeQR2;
		  let otherColorQR = this.props.otherColorQR;
		  let posColorQR = this.props.posColorQR;
		  let bgColorQR = this.props.bgColorQR;
		  let scaleQR = this.props.scaleQR;
		  let crossWidthQR = this.props.crossWidthQR;
		  let posWidhQR = this.props.posWidhQR;
		  let formId = this.props.formId;
		  let icon = this.props.icon;
		  let eyeColorQR = this.props.eyeColorQR;
		  let logoSizeQR = this.props.logoSizeQR;
		  let qrStyleCustom = this.props.qrStyleCustom;
		  let eyeRadiusQR = this.props.eyeRadiusQR;
		  let logoPaddingQR = this.props.logoPaddingQR;
		  let gradientType = this.props.gradientType;
		  let gradientColor1 = this.props.gradientColor1;
		  let gradientColor2 = this.props.gradientColor2;
		  //console.log('base64 ' + icon );		  
		  let imgQR = this.props.imgQR;
		  const isMarginQR= this.props.isMarginQR;
		  //design style
		  let QRstyle = this.props.QRstyle;
	      if (isVisiableQR){
			return(
					  <React.Fragment>
					   <ComponentToPrint ref={this.componentRef} 
						  idQR = {idQR}
						  formId = {formId}
						  valueQR = {valueQR}
						  sizeQR = {sizeQR}
						  sizeCustomQR = {sizeCustomQR}
						  levelQR = {levelQR}			  
						  typeQR = {typeQR}
						  posTypeQR = {posTypeQR}
						  posTypeQR2 = {posTypeQR2}
						  opacityQR = {opacityQR}
						  otherColorQR = {otherColorQR}
						  posColorQR = {posColorQR}
						  bgColorQR = {bgColorQR}
						  eyeColorQR = {eyeColorQR}
						  isMarginQR = {isMarginQR}
						  scaleQR = {scaleQR}
						  crossWidthQR = {crossWidthQR}
						  posWidhQR = {posWidhQR}
						  isVisiableQR = {isVisiableQR}	  			  
						  QRstyle = {QRstyle}
						  icon = {icon}
						  imgQR = {imgQR}
						  logoSizeQR = {logoSizeQR}
						  qrStyleCustom = {qrStyleCustom}
						  eyeRadiusQR = {eyeRadiusQR}
						  logoPaddingQR = {logoPaddingQR}
						  gradientType = {gradientType}
						  gradientColor1 = {gradientColor1}
						  gradientColor2 = {gradientColor2}					   

					   />

					   <div className="download-bar" role="group" aria-label="Скачать QR код">
					   <h3 className="download-bar__title">Скачать</h3>
					   <button type="button" className="download-bar__btn" onClick={() => this.exportAsImage('jpeg')}>
					   JPEG
					   </button>					  
					   <button type="button" className="download-bar__btn" onClick={() => this.exportAsImage('png')}>
						 PNG
					   </button>					   
					   <button type="button" className="download-bar__btn" onClick={() => this.exportAsImage('pdf')}>
						 PDF
					   </button>
					   </div>

					  <UrlInput 
					     isVisiableQR = {isVisiableQR}	
						 valueQR={valueQR}
						 formId={formId}				 
					  />
					  </React.Fragment>

			)
		  }
		  else return null;
			
}

}
export default QRdiv
